/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarytoolsocial3Inputs */

const en_medialibrarytoolsocial3 = /** @type {(inputs: Medialibrarytoolsocial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post`)
};

const de_medialibrarytoolsocial3 = /** @type {(inputs: Medialibrarytoolsocial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrag`)
};

/**
* | output |
* | --- |
* | "Post" |
*
* @param {Medialibrarytoolsocial3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarytoolsocial3 = /** @type {((inputs?: Medialibrarytoolsocial3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarytoolsocial3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarytoolsocial3(inputs)
	return de_medialibrarytoolsocial3(inputs)
});
export { medialibrarytoolsocial3 as "mediaLibraryToolSocial" }